import React from 'react'
import PropTypes from 'prop-types'
import { IconButton, Menu } from '@mui/material'
import MoreIcon from '@mui/icons-material/MoreHoriz'
import { bindTrigger, bindMenu, usePopupState } from 'material-ui-popup-state/hooks'

const More = (props) => (
  <IconButton size="small" {...props}>
    <MoreIcon />
  </IconButton>
)

const DropDown = ({ component, componentProps = {}, popupId, children, onClick, ...rest }) => {
  const popupState = usePopupState({ variant: 'popover', popupId })
  const Component = component || More
  const { children: triggerComponentChildren, ...triggerProps } = componentProps

  return (
    <>
      <Component style={{ cursor: 'pointer' }} {...triggerProps} {...bindTrigger(popupState)}>
        {triggerComponentChildren}
      </Component>
      <Menu
        {...bindMenu(popupState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        {...rest}
        onClick={onClick || popupState.close}
      >
        {children}
      </Menu>
    </>
  )
}

DropDown.propTypes = {
  component: PropTypes.elementType,
  popupId: PropTypes.string,
  children: PropTypes.node,
  componentProps: PropTypes.object,
  onClick: PropTypes.func,
}

export default DropDown
